// extracted by mini-css-extract-plugin
export default {"YouTubeSection":"videoSection_YouTubeSection__azC1z","VideoContainer":"videoSection_VideoContainer__zPPPD","YouTubeIframe":"videoSection_YouTubeIframe__mTTQ5"};